import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from "firebase/app" // eslint-disable-line

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    players: [],
    gamePlayers: [],
    lobbyId: '',
    gameId: '',
    db: {},
    player: {},
    cards: []
  },
  mutations: {
    resetState(state, _payload) {
      state.players = []
      state.gamePlayers = []
      state.lobbyId = ''
      state.gameId = ''
      state.player = {}
      state.cards = []
    },
    setPlayer(state, player) {
      state.player = player
    },
    setCards(state, cards) {
      state.cards = cards
    },
    addPlayer(state, player) {
      state.players.push(player)
    },
    removePlayers(state, players) {
      if (players.length > 0) {
        for (let i = 0; i < players.length; i++) {
          state.players = state.players.filter(x => x.id === players[i])
        }
      }
    },
    removeGamePlayers(state, players) {
      if (players.length > 0) {
        for (let i = 0; i < players.length; i++) {
          state.gamePlayers = state.gamePlayers.filter(x => x.id === players[i])
        }
      }
    },
    addGamePlayer(state, player) {
      state.gamePlayers.push(player)
    },
    updatePlayer(state, player) {
      state.players = state.players.filter(x => x.id !== player.id)
      state.players.push(player)
    },
    updateGamePlayer(state, player) {
      state.gamePlayers = state.gamePlayers.filter(x => x.id !== player.id)
      state.gamePlayers.push(player)
    },
    setLobbyId(state, id) {
      state.lobbyId = id
    },
    setGameId(state, id) {
      state.gameId = id
    },
    changeTeam(state, payload) {
      const targetTeam = payload.targetTeam
      const playerId = payload.playerId
      const player = state.players.find(x => x.id === playerId)
      player.team = targetTeam
    },
    initDb(state, db) {
      state.db = db
    }
  },
  actions: {
    addPlayer({ state, _dispatch, commit }, player) {
      const lobbyId = state.lobbyId
      const players = state.players
      let team
      if (players.length % 2 === 0) {
        team = 'red'
      } else {
        team = 'blue'
      }

      const updates = {}
      updates['lobby/' + lobbyId + '/players/' + player.id] = {
        id: player.id,
        name: player.name,
        team
      }
      state.db.ref().update(updates)
      commit('addPlayer', player)
    }
  },
  modules: {
  }
})
